import React from "react";
import { Box } from "@rebass/grid";
import styled from "styled-components";
import { Arrowdown } from "../Icons";

import { STATUS_IMAGE } from "../../constants";
import {
  ComponentsContainer,
  ComponentValue,
  ExtraValue,
  Row,
  Group,
} from "./style";

const LIMIT = 5;
const TOP_LIMIT = 2;
export const TooltipContent = styled.div`
  padding: 16px;
  max-width: 350px;
  width: auto;
`;

function AffectedComponents({
  collapsible,
  limitInfo,
  componentsByGroup = {},
  componentGroups = [],
}) {
  const [isShowAll, setShowAll] = React.useState({});
  const [isShowAllRows, setShowAllRows] = React.useState(!collapsible);
  const checkIfSubGroup = (id) => {
    const basic = componentGroups.find(
      (d) => d.id?.toString() === id.toString()
    );
    const subgroup = componentGroups.find((a) => a.id === id && a?.parent);
    if (subgroup) {
      const parent = componentGroups.find((b) => b.id === subgroup?.parent);
      const subGroupName = subgroup?.name;
      return (
        <>
          <Group className="parent">
            {parent?.name}
            <span className="divider">/</span>
          </Group>

          <Group>
            {subGroupName}
            <span className="divider">/</span>
          </Group>
        </>
      );
    }
    console.log(basic);
    return (
      <Group className="parent">
        {basic?.name || ""}
        <span className="divider">/</span>
      </Group>
    );
  };
  const rowItems = Object.keys(componentsByGroup);
  let totalCount = 0;
  let skipCount = 0;
  rowItems.forEach((gp, index) => {
    const groupComponents = componentsByGroup[gp] || [];
    if (index === 0) {
      skipCount += groupComponents.length;
    }
    totalCount += groupComponents.length;
  });

  return (
    componentsByGroup &&
    rowItems.length > 0 && (
      <div className="components-affected">
        <ComponentsContainer isShowAllRows={isShowAllRows}>
          <Box color="#475867">Affected services </Box>
          {collapsible && (
            <div
              className="show-all"
              role="none"
              onClick={(e) => {
                e.stopPropagation();
                setShowAllRows(!isShowAllRows);
                if (isShowAllRows) setShowAll({});
              }}
            >
              <span>{`show ${isShowAllRows ? "less" : "all"}`}</span>
              <Arrowdown />
            </div>
          )}
        </ComponentsContainer>
        <Box mt="10px">
          {rowItems?.length > 0 &&
            rowItems
              .slice(0, limitInfo ? 1 : isShowAllRows ? undefined : TOP_LIMIT)
              .map((group) => {
                const groupComponents = componentsByGroup[group] || [];
                const count = limitInfo
                  ? totalCount - (skipCount > LIMIT ? LIMIT : skipCount)
                  : groupComponents.length - LIMIT;
                return (
                  <Row key={`components-group-${group}`}>
                    {group.length > 0 && checkIfSubGroup(group)}
                    {groupComponents
                      .slice(
                        0,
                        limitInfo
                          ? LIMIT
                          : isShowAll[group] || !collapsible
                          ? undefined
                          : LIMIT
                      )
                      .map((component) => (
                        <ComponentValue key={component.id}>
                          {component.status && (
                            <img
                              alt={component.status}
                              src={STATUS_IMAGE[component.status]}
                            />
                          )}
                          {component.name}
                        </ComponentValue>
                      ))}
                    {(((groupComponents.length > LIMIT || isShowAll[group]) &&
                      collapsible) ||
                      limitInfo) &&
                      count > 0 && (
                        <ExtraValue
                          onClick={(e) => {
                            if (!limitInfo) {
                              e.stopPropagation();
                              setShowAll({
                                ...isShowAll,
                                [group]: !isShowAll[group],
                              });
                            }
                          }}
                        >
                          {isShowAll[group] ? "show less" : `+ ${count} more..`}
                        </ExtraValue>
                      )}
                  </Row>
                );
              })}
        </Box>
      </div>
    )
  );
}
export default AffectedComponents;
